import { useState } from 'react';
import { ExternalLink } from 'lucide-react';
import { GeneratedCover } from '@/components/common/Primitives';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

/** Grade do portfólio: clique na imagem para ampliar; o link do conteúdo é opcional. */
export function PortfolioGrid({ items, seed = '' }) {
  const [open, setOpen] = useState(null);

  return (
    <>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-testid="portfolio-grid">
        {items.map((p) => (
          <figure key={p.id} className="overflow-hidden rounded-lg border border-white/10">
            <button
              type="button"
              onClick={() => setOpen(p)}
              className="block w-full cursor-zoom-in text-left"
              aria-label={`Ver imagem: ${p.title}`}
              data-testid="portfolio-item"
            >
              {p.imageUrl ? (
                <img
                  src={p.imageUrl}
                  alt={p.title}
                  loading="lazy"
                  className="aspect-[4/3] w-full object-cover transition-transform duration-300 hover:scale-[1.02]"
                  onError={(e) => { e.currentTarget.style.display = 'none'; }}
                />
              ) : (
                <GeneratedCover seed={p.title + seed} className="aspect-[4/3]" />
              )}
            </button>
            <figcaption className="border-t border-white/10 bg-[#0b0f16] px-3 py-2">
              <div className="text-sm font-medium">{p.title}</div>
              {p.description && <div className="text-[11px] text-muted-foreground">{p.description}</div>}
              {p.linkUrl && (
                <a
                  href={p.linkUrl}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="mt-1 inline-flex items-center gap-1 text-xs text-primary hover:underline"
                  data-testid="portfolio-link"
                >
                  <ExternalLink className="h-3 w-3" /> Ver conteúdo
                </a>
              )}
            </figcaption>
          </figure>
        ))}
      </div>

      <Dialog open={!!open} onOpenChange={(v) => !v && setOpen(null)}>
        <DialogContent className="max-w-4xl border-white/10 bg-[#0b0f16] p-3">
          <DialogTitle className="sr-only">{open?.title}</DialogTitle>
          {open && (
            <>
              {open.imageUrl ? (
                <img src={open.imageUrl} alt={open.title} className="max-h-[70vh] w-full rounded-md object-contain" />
              ) : (
                <GeneratedCover seed={open.title + seed} className="aspect-[4/3] w-full rounded-md" />
              )}
              <div className="mt-3 flex flex-wrap items-center justify-between gap-3 px-1">
                <div>
                  <div className="font-medium">{open.title}</div>
                  {open.description && <div className="text-xs text-muted-foreground">{open.description}</div>}
                </div>
                {open.linkUrl && (
                  <Button asChild size="sm" className="btn-glow">
                    <a href={open.linkUrl} target="_blank" rel="noopener noreferrer nofollow">
                      <ExternalLink /> Acessar conteúdo
                    </a>
                  </Button>
                )}
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}